export const AUTHORIZATION_LABELS = {
  prepaid: "Paid before delivery",
  cash_on_delivery: "Cash on delivery",
  pay_later: "Pay later",
  manual_management_approval: "Special management approval",
};

export const ATTENTION_CONFIG = {
  critical: { label: "Critical", color: "#cf1322", background: "#fff1f0" },
  high: { label: "High", color: "#d46b08", background: "#fff7e6" },
  medium: { label: "Medium", color: "#1677ff", background: "#e6f4ff" },
  normal: { label: "Normal", color: "#389e0d", background: "#f6ffed" },
};

export const NEXT_ACTION_LABELS = {
  resolve_warranty_case: "Complete warranty work",
  review_customer_change: "Review customer's change request",
  settle_overdue_obligation: "Complete overdue payment",
  settle_open_obligation: "Complete pending payment",
  resolve_residual_inventory: "Decide what to do with leftover parts",
  settle_financial_obligation: "Complete pending payment",
  assign_procurement: "Assign a purchaser",
  monitor_procurement: "Follow up purchasing",
  monitor_logistics: "Complete pickup or delivery",
};

export const CLOSURE_LABELS = {
  delivered: "Delivered",
  refunded: "Refunded",
  cancelled: "Cancelled",
  written_off: "Written off",
  mixed: "Mixed outcome",
};

export const OPERATIONS_SOCKET_EVENTS = [
  "operations_v2:handover_authorized",
  "operations_v2:owner_reassigned",
  "operations_v2:delivery_address_changed",
  "operations_v2:procurement_assigned",
  "operations_v2:procurement_group_reassigned",
  "operations_v2:procurement_supplier_overridden",
  "operations_v2:map_task_updated",
  "operations_v2:change_requested",
  "operations_v2:change_decided",
  "operations_v2:change_refund_approval_requested",
  "operations_v2:change_po_revised",
  "operations_v2:delivery_intercepted",
  "operations_v2:purchased_change_resolved",
  "operations_v2:zoho_orders_generated",
  "operations_v2:zoho_document_archive_changed",
  "operations_v2:zoho_purchase_order_cancelled",
  "operations_v2:supplier_unavailable",
  "operations_v2:price_variance_reported",
  "operations_v2:price_variance_approved",
  "operations_v2:units_acquired",
  "operations_v2:logistics_task_created",
  "operations_v2:custody_handover",
  "operations_v2:logistics_task_started",
  "operations_v2:customer_delivery_accepted",
  "operations_v2:logistics_stop_arrived",
  "operations_v2:logistics_pickup_confirmed",
  "operations_v2:logistics_task_failed",
  "operations_v2:customer_delivery_refused",
  "operations_v2:logistics_task_completed",
  "operations_v2:logistics_task_escalated",
  "operations_v2:custody_offer_changed",
  "operations_v2:logistics_task_reassigned",
  "operations_v2:sync_failure_changed",
  "operations_v2:warranty_case_opened",
  "operations_v2:warranty_pickup_failed",
  "operations_v2:supplier_claim_decided",
  "operations_v2:customer_resolution_requested",
  "operations_v2:customer_resolution_applied",
  "operations_v2:residual_inventory_recorded",
  "operations_v2:residual_disposition_requested",
  "operations_v2:residual_disposition_recorded",
  "operations_v2:money_movement_confirmed",
  "operations_v2:money_movement_allocated",
  "operations_v2:customer_address_concern",
];
